export const REQUEST_SEND_FORGOT_EMAIL = 'REQUEST_SEND_FORGOT_EMAIL';
export const SEND_FORGOT_EMAIL_SUCCESS = 'SEND_FORGOT_EMAIL_SUCCESS';
export const SEND_FORGOT_EMAIL_FAILURE = 'SEND_FORGOT_EMAIL_FAILURE';

export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
